export const PAYMENT_WHATSAPP_NUMBER = '916380413953';

// Use the same saved order displayed by confirmation. The rule API verifies ownership.
export const findQrPaymentOrder = (orders, context, userId) => {
    if (!userId || !Array.isArray(orders) || !orders.length) return null;
    if (context && String(context.userId) !== String(userId)) return null;
    const order = context?.orderNumber
        ? orders.find(item => String(item.OrderNumber) === String(context.orderNumber))
        : orders[0];
    if (!order?.OrderNumber || !Number.isFinite(Number(order.OrderTotal)) || Number(order.OrderTotal) <= 0) return null;
    return { orderNumber: String(order.OrderNumber), amount: Number(order.OrderTotal) };
};

export const buildOrderUpiLink = (amount, orderNumber, upiId, payeeName) => {
    if (typeof upiId !== 'string' || upiId.length > 150 || !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/.test(upiId)
        || typeof payeeName !== 'string' || !payeeName.trim() || payeeName.length > 100
        || typeof orderNumber !== 'string' || !orderNumber.trim() || orderNumber.length > 500
        || /[\u0000-\u001f\u007f]/.test(payeeName + orderNumber)
        || typeof amount !== 'number' || !Number.isFinite(amount) || amount < 0.01
        || !Number.isSafeInteger(Math.round(amount * 100))
        || Math.abs(amount * 100 - Math.round(amount * 100)) > 0.000001) return '';
    const parameters = new URLSearchParams({
        pa: upiId,
        pn: payeeName,
        am: Number(amount).toFixed(2),
        cu: 'INR',
        tn: `Order ${orderNumber}`,
    });
    return `upi://pay?${parameters.toString()}`;
};

// Eligibility is decided by the setup API using the saved shipping address and total.
export const getConfiguredQrPayment = (response, expectedOrderNumber) => {
    if (response?.status !== 200) return null;
    const data = response.data;
    const orderNumber = data?.orderNumber ?? data?.OrderNumber;
    const amount = Number(data?.amount ?? data?.Amount);
    const configuredRules = data?.rules ?? data?.Rules;
    if (!orderNumber || String(orderNumber) !== String(expectedOrderNumber)
        || !Number.isFinite(amount) || amount <= 0 || !Array.isArray(configuredRules)) return null;
    const rules = configuredRules.map(rule => ({
        id: rule?.id ?? rule?.Id,
        name: rule?.name ?? rule?.Name,
        upiId: rule?.upiId ?? rule?.UpiId,
        payeeName: rule?.payeeName ?? rule?.PayeeName,
    })).filter(rule => typeof rule.upiId === 'string' && /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/.test(rule.upiId)
        && typeof rule.payeeName === 'string' && rule.payeeName.trim());
    return rules.length ? { orderNumber: String(orderNumber), amount, rules } : null;
};
